import { syncV1ToV3 } from '@/common/utils/recentlyViewed/recentlyViewedMigration';
import { elysiumLogger } from '@/common/utils/sharedUtils';
import { ArtworkOrientation } from 'generatedBfw/static';

export const MAX_RECENTLY_VIEWED_ITEMS = 100;
export const RECENTLY_VIEWED_KEY_V1 = 'recentlyViewed';
export const RECENTLY_VIEWED_KEY_V2 = 'recentlyViewedV2';
export const RECENTLY_VIEWED_KEY_V3 = 'recentlyViewedV3';

export interface RecentlyViewedProductV1 {
  itemCollectionId: string;
  orientation: ArtworkOrientation;
  image: string;
  title: string;
}

/**
 * Data model for single product that is stored in local storage. Names are shortened to reduce the size of the data.
 */
export interface RecentlyViewedProductV3 {
  id: number; // externalId
  inId: number; // internalId
  orient: ArtworkOrientation; // orientation
  imgCore: string; // image core url
  alt: string; // title
}

export interface RecentlyViewedProductV1 {
  id: number;
  itemCollectionId: string;
  orientation: ArtworkOrientation;
  image: string;
  title: string;
}

export const getRecentlyViewed = (): RecentlyViewedProductV3[] => {
  // RecentlyViewed migration to be removed after most of users are migrated to V2 (probably start 2024)
  const migratedRecentlyViewed = syncV1ToV3();
  if (migratedRecentlyViewed) {
    return migratedRecentlyViewed;
  }

  try {
    const productsV3Raw = localStorage.getItem(RECENTLY_VIEWED_KEY_V3);
    if (productsV3Raw) {
      return JSON.parse(productsV3Raw) ?? [];
    }
  } catch (e) {
    elysiumLogger().error('useRecentlyViewed error', e);
  }
  return [];
};

export const addRecentlyViewed = (product: RecentlyViewedProductV3) => {
  const recentlyViewed = getRecentlyViewed().filter((item) => item.id !== product.id);
  const newRecentlyViewed = [product, ...recentlyViewed].splice(0, MAX_RECENTLY_VIEWED_ITEMS);

  localStorage.setItem(RECENTLY_VIEWED_KEY_V3, JSON.stringify(newRecentlyViewed));
};
